import { createSlice } from '@reduxjs/toolkit';

const initialState = { transcribe: null, error: null };

const transcribeSlice = createSlice({
  name: 'transcribe',
  initialState,
  reducers: {
    transcribeHandler(state, action) {
      state.transcribe = action.payload.transcribeData || null;
      state.error = action.payload.error || null;
    },
    clearTranscribe(state) {
      state.transcribe = null;
      state.error = null;
    },
  },
});
export const transcribeAction = transcribeSlice.actions;
export default transcribeSlice;